import React, { useContext } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { ItemDropdownMenu, Pager, PODropdownMenu, SortHeader } from './';
import { dateHelpers, helpers } from '../utils';
import { useNavigate } from 'react-router-dom';
import { constants, UserContext } from "../utils";
import classNames from 'classnames';

export default function VendorInvoiceGrid({ data, working, page, totalPages, sort, exportExcel, vendorParam, hidePager = false }) {
   const nav = useNavigate();
   const userCtx = useContext(UserContext);
   const { currentUser } = userCtx;
   return (
      <>
         <Row className={'mb-2'}>
            <Col className={classNames("", { "d-none": hidePager })}>
               <Pager
                  callBack={page.callback}
                  sizeCallback={page.sizeCallback}
                  pageNumber={page.number}
                  pageSize={page.size}
                  totalPages={totalPages}
                  allowAll={page.allowAll}
                  downloading={working}
               />
            </Col>
            <Col className="transparent-background">
               {data && data.length
                  ? (<Button
                     title="Download as .xlsx"
                     className="shredButtonExcel float-end ms-2"
                     onClick={exportExcel}
                     disabled={working}
                  >
                     <FontAwesomeIcon icon="file-excel" size="lg" />
                  </Button>)
                  : null
               }
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th>
                     <SortHeader
                        displayName={"INV #"}
                        field="InvoiceNumber"
                        sortDirection={sort.direction}
                        sorted={sort.field === "InvoiceNumber"}
                        callback={sort.callback}
                     />
                  </th>
                  <th>
                     <SortHeader
                        displayName={"Inv Date"}
                        field="InvoiceDate"
                        sortDirection={sort.direction}
                        sorted={sort.field === "InvoiceDate"}
                        callback={sort.callback}
                     />
                  </th>
                  <th>
                     <SortHeader
                        displayName={<span>Receipt<br />Date</span>}
                        field="ReceiptDate"
                        sortDirection={sort.direction}
                        sorted={sort.field === "ReceiptDate"}
                        callback={sort.callback}
                     />
                  </th>
                  <th>Receipt #</th>
                  <th>
                     <SortHeader
                        displayName={"PO #"}
                        field="PONumber"
                        sortDirection={sort.direction}
                        sorted={sort.field === "PONumber"}
                        callback={sort.callback}
                     />
                  </th>
                  <th>Containers</th>
                  <th>Item</th>
                  <th>Qty<br />Shipped</th>
                  <th>Qty<br />Invoiced</th>
                  <th>Unit<br />Cost</th>
                  <th>Ext<br />Cost</th>
                  <th>Reference #</th>
                  <th>Type</th>
                  <th>
                     <SortHeader
                        displayName={<span>Paid<br />Date</span>}
                        field="PaymentDate"
                        sortDirection={sort.direction}
                        sorted={sort.field === "PaymentDate"}
                        callback={sort.callback}
                     />
                  </th>
                  <th>Days</th>
               </tr>
            </thead>
            <tbody>
               {_.map(data, (datum, idx) => {
                  const previousInvoice = data[idx - 1] ? data[idx - 1].invoiceNumber : undefined;
                  const onSameInvoice = previousInvoice === datum.invoiceNumber;
                  return (
                     <tr key={idx} className={`tr-${idx % 2 === 0 ? "primary" : "secondary"}`}>
                        <td>{onSameInvoice ? null : datum.invoiceNumber}</td>
                        <td>{onSameInvoice ? null : datum.invoiceDate === "0001-01-01T00:00:00" ? "" : dateHelpers.toLongDateString(datum.invoiceDate)}</td>
                        <td>{onSameInvoice ? null : datum.receiptDate === "0001-01-01T00:00:00" ? "" : dateHelpers.toLongDateString(datum.receiptDate)}</td>
                        <td>{onSameInvoice ? null : datum.receiptNumber}</td>
                        <PODropdownMenu
                           poNumber={datum.poNumber}
                           alignTop={true}
                           attachmentCount={datum.poAttachmentCount}
                           showAddContainer
                           showAddCost={currentUser?.isAdmin || currentUser?.isPowerUser || currentUser?.isPurchasingEdit}
                           itemNumber={datum.itemNumber}
                           containers={datum.containers}
                        />
                        <td>{datum.containers}</td>
                        <ItemDropdownMenu
                           itemNumber={datum.itemNumber}
                           itemDescription={datum.itemWithDescription}
                           attachmentCount={datum.itemAttachmentCount}
                           alignTop={true}
                        />
                        <td>{datum.qtyShipped.toLocaleString()}</td>
                        <td>{datum.invoiceQty.toLocaleString()}</td>
                        <td>{helpers.formatCurrency(datum.unitCost)}</td>
                        <td>{helpers.formatCurrency(datum.extendedCost)}</td>
                        <td>{datum.paymentNumber}</td>
                        <td>{datum.paymentType}</td>
                        <td>{datum.paymentDate === "1900-01-01T00:00:00" || !datum.paymentType.startsWith("Payment") ? "" : dateHelpers.toLongDateString(datum.paymentDate)}</td>
                        <td>{datum.paymentDate === "1900-01-01T00:00:00" || !datum.paymentType.startsWith("Payment") ? "" : datum.payDays}</td>
                     </tr>
                  )
               })}
            </tbody>
            <tfoot className="table-footer">
               <tr>
                  <td colSpan={8} />
                  <td>{helpers.formatNumberWithThousands(_.round(_.sumBy(data, datum => datum.invoiceQty)))}</td>
                  <td />
                  <td>{helpers.formatCurrency(_.sumBy(data, datum => datum.extendedCost))}</td>
                  <td colSpan={4} />
               </tr>
            </tfoot>
         </Table>
         <Row className={classNames("mt-2", { "d-none": hidePager })}>
            <Col xs={{ offset: 6, size: 6 }} className="transparent-background">
               {data && data.length
                  ? (<Button
                     title="show invoices search"
                     className="shredButton float-end ms-2"
                     onClick={() => nav(constants.ENDPOINTS.vendorInvoices, { state: { vendor: vendorParam, type: "showSearch" } })}
                     disabled={working}
                  >
                     More Invoices
                  </Button>)
                  : null
               }
            </Col>
         </Row>
      </>
   );
}